/**
 * After checkout, login/userAcc often still carries the pre-order currentCart.
 * Strip it so CartSynch cannot restore items into the cleared local cart.
 */
export function withClearedCurrentCart(userAcc) {
  if (userAcc == null || userAcc === '') return userAcc
  return { ...userAcc, currentCart: [] }
}

/**
 * Hydrate local cart from account currentCart once per user identity.
 * Re-applying on every userAcc update restores stale carts after checkout.
 */
export function shouldHydrateCartFromUserAcc({
  userPhone,
  currentCart,
  userKey,
  lastHydratedUserKey,
}) {
  if (!userPhone) return false
  if (currentCart == null) return false
  if (!userKey) return false
  if (lastHydratedUserKey === userKey) return false
  return true
}
